/**
 * Normalizes paginated admin API payloads (axios interceptor already returns `response.data`).
 */
export function extractPaginatedResponse(payload) {
  const backend = payload?.data ?? payload;
  const list = Array.isArray(backend?.data)
    ? backend.data
    : Array.isArray(backend)
      ? backend
      : [];
  const rawMeta =
    payload?.pagination ?? payload?.meta ?? backend?.meta ?? {};
  return {
    list,
    meta: {
      total: rawMeta.total ?? rawMeta.count ?? list.length,
      page: rawMeta.current_page ?? rawMeta.page ?? 1,
      perPage: rawMeta.per_page ?? rawMeta.perPage ?? 10,
      lastPage: rawMeta.lastPage ?? rawMeta.last_page,
    },
  };
}
